import { AppConfigState } from './config/config.state';
import { CoursesState } from './course';
import { LiveClassState } from './live-class/live-class.state';
import { OrderState } from './order/order.state';
import { ResourceState } from './resource';
import { UserSessionsState } from './user-sessions/sessions.state';
import { UserState } from './users/users.state';

export interface State {
  courses: CoursesState;
  users: UserState;
  resources: ResourceState;
  orders: OrderState;
  liveClass: LiveClassState;
  config: AppConfigState;
  userSessions: UserSessionsState;
}
